import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';
import {
  checkIfHasAllowedCharacters,
  checkIfHasAlphaNumeric,
  stringOptimumLength,
  firstCharIsNotSpecialChar
} from '../../../util/stringUtils';

export const validateItemLabel = (labelName, items, item) => {
  if (labelName && labelName.trim() !== '') {
    if (!checkIfHasAllowedCharacters(labelName)) {
      return 'Following special characters are allowed :./-&$#@%_(){}\\';
    }

    if (!firstCharIsNotSpecialChar(labelName)) {
      return 'Label name should not start with a special character.';
    }

    if (!checkIfHasAlphaNumeric(labelName)) {
      return 'Label name cannot only contain special characters';
    }

    if (!stringOptimumLength(labelName, 3, 50)) {
      return 'Please provide a label name ranging from 3-50 characters.';
    }

    if (
      !isEmpty(
        find(
          items,
          (o) => o.index !== item.index && o.labelName === trim(labelName)
        )
      )
    ) {
      return 'Label name should not be repeated twice within a column.';
    }
  } else {
    return 'Please provide a label name.';
  }

  return null;
};

export const validateItemName = (itemName, items, item) => {
  let errorMessage = null;
  if (itemName && itemName.trim() !== '') {
    // check if there is an existing item with the same column name
    items.forEach((currentCheckingItem) => {
      if (
        currentCheckingItem.index !== item.index &&
        currentCheckingItem.itemName === itemName
      ) {
        errorMessage =
          'Item name should not be repeated twice within a column.';
      }
    });
  } else {
    errorMessage = 'Please choose an item.';
  }

  return errorMessage;
};
